import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Column, Loader, Spinner, Row, Drawer } from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import translations from 'src/internationalisation/translation-map.json';
import {
  showDeleteCurrencyTemplateModalUpdated,
  showCurrencyTemplateFormUpdated,
} from 'store/entities/company-settings/company-settings';

import { CurrencyTemplateList } from './currency.list';
import { CurrencyTemplateForm } from './currency.form';
import { CurrencyTemplateDeleteModal } from './currency.delete.modal';

const Currency = ({ companySettings, showCurrencyTemplateFormUpdated, showDeleteCurrencyTemplateModalUpdated }) => {
  const { t } = useTranslation();
  const [selectedId, setSelectedId] = useState(null);

  const { currencyTemplate, isAdding, showDeleteCurrencyTemplateModal, showCurrencyTemplateForm } = companySettings;

  const onClickDelete = (id) => {
    setSelectedId(id);
    showDeleteCurrencyTemplateModalUpdated(true);
    showCurrencyTemplateFormUpdated(false);
  };

  const [drawerWidth, setDrawerWidth] = useState(300);
  return (
    <>
      <Column scroll spacing={0}>
        {isAdding && (
          <Loader text={t(translations.fetching)} theme="light" cover>
            <Spinner dark />
          </Loader>
        )}
        <Row spacing={0} height="100%">
          <Drawer width={drawerWidth} closedWidth={50} open button border onResize={(width) => setDrawerWidth(width)}>
            <Column scroll width="250px" borderRight spacing={0}>
              <CurrencyTemplateList
                onClickDelete={onClickDelete}
                currencyTemplates={currencyTemplate}
                isAdding={isAdding}
              />
            </Column>
          </Drawer>
          <Column scroll padding>
            {showCurrencyTemplateForm && (
              <>
                <CurrencyTemplateForm />
              </>
            )}
          </Column>
        </Row>
      </Column>
      {showDeleteCurrencyTemplateModal && (
        <CurrencyTemplateDeleteModal
          currencyTemplateId={selectedId}
          setModalVisible={showDeleteCurrencyTemplateModalUpdated}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ entities }) => {
  const { companySettings } = entities;
  return {
    companySettings,
  };
};

const mapDispatchToProps = {
  showCurrencyTemplateFormUpdated,
  showDeleteCurrencyTemplateModalUpdated,
};

const Container = connect(mapStateToProps, mapDispatchToProps)(Currency);

export { Container as Currency };
